import type { ReviewOverviewProjectResource } from "@/types_api/backend/transport/get_review_overview_response"
import type { ReviewProjectResource } from "@/types_api/backend/transport/update_review_project_response"
import type { HumanReviewProject } from "@/types/api/HumanReviewProject"

interface ProjectWithBlindLabelingShownMetricIds {
  blind_labeling_shown_metric_ids?: string[] | null
}

function getBlindLabelingShownMetricIds(project: object): string[] | null {
  return (
    (project as ProjectWithBlindLabelingShownMetricIds)
      .blind_labeling_shown_metric_ids ?? null
  )
}

export function mapReviewOverviewProjectToHumanReviewProject(
  project: ReviewOverviewProjectResource,
): HumanReviewProject {
  return {
    ulid: project.ulid,
    name: project.name,
    description: project.description ?? null,
    organization_id: project.organization_id,
    created_at: project.created_at,
    last_updated_at: project.last_updated_at,
    assignees: project.assignees,
    linked_simulation_ids: project.linked_simulation_ids,
    linked_metric_ids: project.linked_metric_ids,
    notifications: project.notifications,
    opted_out_assignees: project.opted_out_assignees ?? [],
    project_type: project.project_type,
    project_rules: project.project_rules ?? null,
    blind_labeling_shown_metric_ids: getBlindLabelingShownMetricIds(project),
    review_label_options: project.review_label_options ?? null,
    review_label_enabled: project.review_label_enabled ?? null,
    review_label_input_mode: project.review_label_input_mode ?? null,
    review_label_selection_mode: project.review_label_selection_mode ?? null,
  }
}

export function mapReviewProjectResourceToHumanReviewProject(
  project: ReviewProjectResource,
): HumanReviewProject {
  const projectType = project.project_type.replace(/^PROJECT_/, "")

  return {
    ulid: project.id,
    name: project.display_name,
    description: project.description ?? null,
    organization_id: "",
    created_at: project.create_time,
    last_updated_at: project.update_time,
    assignees: project.assignees,
    linked_simulation_ids: project.linked_simulation_ids,
    linked_metric_ids: project.linked_metric_ids,
    notifications: project.notifications,
    opted_out_assignees: [],
    project_type:
      projectType === "COLLABORATIVE" ? "COLLABORATIVE" : "INDIVIDUAL",
    project_rules: project.project_rules ?? null,
    blind_labeling_shown_metric_ids: getBlindLabelingShownMetricIds(project),
    review_label_options: project.review_label_options ?? null,
    review_label_enabled: project.review_label_enabled ?? null,
    review_label_input_mode: project.review_label_input_mode ?? null,
    review_label_selection_mode: project.review_label_selection_mode ?? null,
    enforced_collaboration: project.enforced_collaboration ?? false,
    allow_metric_skipping: project.allow_metric_skipping ?? false,
    skippable_metric_ids: project.skippable_metric_ids ?? null,
  }
}
